/**
 * Ce fichier permets d'afficher la positions en réel sous forme d'un cercle
 *
 * © Moustapha HENNAWI - Click and Take off - 2021
 */

/*-------------------------------------------------------------------------------------------*/
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import circle from '@turf/circle';

import { map } from './Map';
import { selectPositionsArray } from '../createSelectorUtils';

/*-------------------------------------------------------------------------------------------*/

export default function AccuracyMap() {
  const id = 'accuracy';

  const positions = useSelector(selectPositionsArray);

  useEffect(() => {
    map.addSource(id, {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: []
      }
    });
    map.addLayer({
      source: id,
      id,
      type: 'fill',
      filter: ['all', ['==', '$type', 'Polygon']],
      paint: {
        'fill-color': '#3bb2d0',
        'fill-outline-color': '#3bb2d0',
        'fill-opacity': 0.25
      }
    });

    return () => {
      if (map.getLayer(id)) {
        map.removeLayer(id);
      }
      if (map.getSource(id)) {
        map.removeSource(id);
      }
    };
  }, []);

  useEffect(() => {
    const positionsFeature = () => ({
      type: 'FeatureCollection',
      features: positions
        .filter((position) => position.accuracy > 0)
        .map((position) =>
          circle([position.longitude, position.latitude], position.accuracy * 0.001)
        )
    });

    if (map.getSource(id) !== undefined) {
      map.getSource(id).setData(positionsFeature());
    }
  }, [positions]);

  return null;
}
